import {
  ActivityStatus,
  ActivityType,
} from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { getRoomsListURL } from './roomsURLs';

export interface Room {
  name: string;
  default: boolean;
  inMenu: boolean;
  shareUrl: string;
  showbieClassId: string;
  showbieClassName: string;
  active: boolean;
  id: number;
  rostered: boolean;
  studentsLoggedIn?: number;
  studentCount?: number;
  quizName?: string;
  activityType: ActivityType;
  state: ActivityStatus;
}

interface GetRoomListResponse {
  rooms: Array<Room>;
}

export async function getRoomsList() {
  const roomListURL = getRoomsListURL();
  const {
    data: { rooms },
  } = await axios.get<GetRoomListResponse>(roomListURL.href);

  return rooms;
}
